import { createSlice } from "@reduxjs/toolkit";

interface authoringViewInitialState {
  view: "table" | "card";
  filterType: string;
}

const INIT_STATE: authoringViewInitialState = {
  view: "table",
  filterType: ""
};

export const AuthoringViewSlice = createSlice({
  name: "AuthoringViewSlice",
  initialState: INIT_STATE,
  reducers: {
    setState: (state, action) => {
      state.view = action.payload;
    },
    setFilterType: (state, action) => {
      state.filterType = action.payload;
    }
  }
});
